import React from 'react'
import MuiTooltip from '@material-ui/core/Tooltip'
import useStyles from './styles'

const Tooltip = props => {
  const classes = useStyles()
  return (
    <MuiTooltip
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      enterTouchDelay={100}
      {...props}
    />
  )
}

export default Tooltip
